<ng-template #modal let-modal>
  <div class="modal-header">
    <h5 class="q-c-main q-bold">Création du stage</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-modal p-0">
      <div class="d-flex align-items-center mb-4">
        <button *ngIf="SelectedProduct && SelectedProduct.id != '' " class="q-btn q-main" (click)="SaveBo()"><i class="fas fa-save"></i></button>

        <!--#region Popover CATALOGUE / ACTION-->
        <div class="rounded-button q-dark-secondary mx-1 q-pointer font-weight-bold"
             [ngClass]="[!SelectedProduct || SelectedProduct.id === '' ? 'q-danger' : '']"
             [ngbPopover]="popCatalogueAction"
             placement="bottom"
             [autoClose]="'outside'"
             #p2="ngbPopover"
             (click)="CatPopover = p2;"
             style="min-height: 30px;font-size: 13px;">
          {{SelectedProduct.value}}
          <i class="fas fa-shopping-cart ml-2"></i>
        </div>
        <ng-template #popCatalogueAction>
          <div *ngIf="ComboCatalogues.length > 0" (click)="showCombo('CATALOGUE',p2)" class="select-type q-pointer px-2">Catalogue produit</div>
          <div *ngIf="ComboTypeOffres.length > 0" (click)="showCombo('ACTION',p2)" class="select-type q-pointer px-2">Action</div>
          <div *ngIf="ComboCatalogues.length == 0 && ComboTypeOffres.length == 0"  class="select-type q-pointer px-2">Votre catalogue est vide</div>
        </ng-template>
        <!--#endregion-->
        <!--#region POPOVER CURSUS-->
        <div class="rounded-button q-dark-secondary mx-1 q-pointer font-weight-bold"
             [ngbPopover]="popCursus"
             placement="bottom"
             [autoClose]="'outside'"
             #p1="ngbPopover"
             (click)="CursusPopover = p1"
             style="min-height:30px;font-size:13px;">
          <i class="fas fa-columns mr-1"></i>
          {{SelectedCursus.value}}
        </div>
        <ng-template #popCursus>
          <ng-container *ngFor="let cursus of ComboCursus">
            <div class="select-type q-pointer px-2" (click)="OnChangeCursus(cursus)">{{cursus.value}}</div>
          </ng-container>
        </ng-template>
        <!--#endregion-->
      </div>
      <div class="row mb-4" *ngIf="showComboType=='CATALOGUE'">
        <select class="q-main-select col-4" [(ngModel)]="valueCatalogue" (change)="onChangeSelect($event.target.value,'CATALOGUE')">
          <option disabled selected value="">Catalogues</option>
          <option *ngFor="let catalogue of ComboCatalogues" [value]="catalogue.id">{{catalogue.value}}</option>
        </select>

        <select class="q-main-select col-4" [(ngModel)]="valueCategorie" (change)="onChangeSelect($event.target.value,'CATEGORIE')" [disabled]="!valueCatalogue">
          <option disabled selected value="">Categories</option>
          <option *ngFor="let categ of ComboCategories" [value]="categ.id">{{categ.value}}</option>
        </select>

        <select class="q-main-select col-4" [(ngModel)]="valueProduit" (change)="onChangeSelect($event.target.value,'PRODUIT')" [disabled]="!valueCategorie">
          <option disabled selected value="">Produits</option>
          <option *ngFor="let prod of ComboProduits" [value]="prod.id">{{prod.value}}</option>
        </select>
      </div>
      <div class="row mb-4" *ngIf="showComboType=='ACTION'">
        <select class="q-main-select col-4" [(ngModel)]="valueOffre" (change)="onChangeSelect($event.target.value,'OFFRE')">
          <option disabled selected value="">Offres</option>
          <option *ngFor="let type of ComboTypeOffres" [value]="type.id">{{type.value}}</option>
        </select>

        <select class="q-main-select col-4" [(ngModel)]="valueFormation" (change)="onChangeSelect($event.target.value,'FORMATION')" [disabled]="!valueOffre">
          <option disabled selected value="">Formations</option>
          <option *ngFor="let form of ComboFormations" [value]="form.id">{{form.value}}</option>
        </select>

        <select class="q-main-select col-4" [(ngModel)]="valueAction" (change)="onChangeSelect($event.target.value,'ACTION')" [disabled]="!valueFormation">
          <option disabled selected value="">Actions</option>
          <option *ngFor="let action of ComboActions" [value]="action.id">{{action.value}}</option>
        </select>
      </div>
      <q-bodisplay *ngIf="BoReady" class="w-100 h-100 mb-5" [item]="BoModel" [globalsave]="Save" (sendEvent)="getEvent($event)" (boReady)="BoReady=true"></q-bodisplay>
    </div>
  </div>
</ng-template>
